// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rNJQ","top":"styles_top__2Rn6n"};